export default "__VITE_ASSET__BY309EpL__"